// extracted by mini-css-extract-plugin
module.exports = {"main-component":"flagIcon_main-component__2jbE3"};